// Auto-added UI translations (batch 9f): the /images gallery's dump category
// names, descriptions, channel labels and folder names.
export const X9F: Record<string, Record<string, string>> = {
  "Card Renders": {
    eng: "Card Renders",
    deu: "Karten-Renderings",
    esp: "Renders de cartas",
    fra: "Rendus de cartes",
    ita: "Render delle carte",
    jpn: "カードのレンダリング",
    kor: "카드 렌더링",
    pol: "Rendery kart",
    ptb: "Renderizações de cartas",
    rus: "Рендеры карт",
    spa: "Renders de cartas",
    tha: "ภาพเรนเดอร์การ์ด",
    tur: "Kart Görselleri",
    zhs: "卡牌渲染图",
    zht: "卡牌渲染圖",
  },
  Animations: {
    eng: "Animations",
    deu: "Animationen",
    esp: "Animaciones",
    fra: "Animations",
    ita: "Animazioni",
    jpn: "アニメーション",
    kor: "애니메이션",
    pol: "Animacje",
    ptb: "Animações",
    rus: "Анимации",
    spa: "Animaciones",
    tha: "แอนิเมชัน",
    tur: "Animasyonlar",
    zhs: "动画",
    zht: "動畫",
  },
  "Monster Renders": {
    eng: "Monster Renders",
    deu: "Monster-Renderings",
    esp: "Renders de monstruos",
    fra: "Rendus de monstres",
    ita: "Render dei mostri",
    jpn: "モンスターのレンダリング",
    kor: "몬스터 렌더링",
    pol: "Rendery potworów",
    ptb: "Renderizações de monstros",
    rus: "Рендеры монстров",
    spa: "Renders de monstruos",
    tha: "ภาพเรนเดอร์มอนสเตอร์",
    tur: "Canavar Görselleri",
    zhs: "怪物渲染图",
    zht: "怪物渲染圖",
  },
  "Monster Skins": {
    eng: "Monster Skins",
    deu: "Monster-Skins",
    esp: "Aspectos de monstruos",
    fra: "Skins de monstres",
    ita: "Skin dei mostri",
    jpn: "モンスターのスキン",
    kor: "몬스터 스킨",
    pol: "Skórki potworów",
    ptb: "Skins de monstros",
    rus: "Скины монстров",
    spa: "Aspectos de monstruos",
    tha: "สกินมอนสเตอร์",
    tur: "Canavar Kostümleri",
    zhs: "怪物皮肤",
    zht: "怪物外觀",
  },
  "Character Renders": {
    eng: "Character Renders",
    deu: "Charakter-Renderings",
    esp: "Renders de personajes",
    fra: "Rendus de personnages",
    ita: "Render dei personaggi",
    jpn: "キャラクターのレンダリング",
    kor: "캐릭터 렌더링",
    pol: "Rendery postaci",
    ptb: "Renderizações de personagens",
    rus: "Рендеры персонажей",
    spa: "Renders de personajes",
    tha: "ภาพเรนเดอร์ตัวละคร",
    tur: "Karakter Görselleri",
    zhs: "角色渲染图",
    zht: "角色渲染圖",
  },
  "Character Forms": {
    eng: "Character Forms",
    deu: "Charakterformen",
    esp: "Formas de personajes",
    fra: "Formes de personnages",
    ita: "Forme dei personaggi",
    jpn: "キャラクターのフォーム",
    kor: "캐릭터 형태",
    pol: "Formy postaci",
    ptb: "Formas de personagens",
    rus: "Формы персонажей",
    spa: "Formas de personajes",
    tha: "ร่างของตัวละคร",
    tur: "Karakter Formları",
    zhs: "角色形态",
    zht: "角色形態",
  },
  "Relic Renders": {
    eng: "Relic Renders",
    deu: "Relikt-Renderings",
    esp: "Renders de reliquias",
    fra: "Rendus de reliques",
    ita: "Render delle reliquie",
    jpn: "レリックのレンダリング",
    kor: "유물 렌더링",
    pol: "Rendery reliktów",
    ptb: "Renderizações de relíquias",
    rus: "Рендеры реликвий",
    spa: "Renders de reliquias",
    tha: "ภาพเรนเดอร์เรลิก",
    tur: "Kalıntı Görselleri",
    zhs: "遗物渲染图",
    zht: "遺物渲染圖",
  },
  "Potion Renders": {
    eng: "Potion Renders",
    deu: "Trank-Renderings",
    esp: "Renders de pociones",
    fra: "Rendus de potions",
    ita: "Render delle pozioni",
    jpn: "ポーションのレンダリング",
    kor: "물약 렌더링",
    pol: "Rendery mikstur",
    ptb: "Renderizações de poções",
    rus: "Рендеры зелий",
    spa: "Renders de pociones",
    tha: "ภาพเรนเดอร์โพชัน",
    tur: "İksir Görselleri",
    zhs: "药水渲染图",
    zht: "藥水渲染圖",
  },
  "Backgrounds (Scenes)": {
    eng: "Backgrounds (Scenes)",
    deu: "Hintergründe (Szenen)",
    esp: "Fondos (escenas)",
    fra: "Arrière-plans (scènes)",
    ita: "Sfondi (scene)",
    jpn: "背景（シーン）",
    kor: "배경 (장면)",
    pol: "Tła (sceny)",
    ptb: "Planos de fundo (cenas)",
    rus: "Фоны (сцены)",
    spa: "Fondos (escenas)",
    tha: "ฉากหลัง (ฉาก)",
    tur: "Arka Planlar (Sahneler)",
    zhs: "背景（场景）",
    zht: "背景（場景）",
  },
  "Card Frames": {
    eng: "Card Frames",
    deu: "Kartenrahmen",
    esp: "Marcos de cartas",
    fra: "Cadres de cartes",
    ita: "Cornici delle carte",
    jpn: "カードフレーム",
    kor: "카드 테두리",
    pol: "Ramki kart",
    ptb: "Molduras de cartas",
    rus: "Рамки карт",
    spa: "Marcos de cartas",
    tha: "กรอบการ์ด",
    tur: "Kart Çerçeveleri",
    zhs: "卡牌边框",
    zht: "卡牌邊框",
  },
  "Enchantment Badges": {
    eng: "Enchantment Badges",
    deu: "Verzauberungs-Abzeichen",
    esp: "Insignias de encantamientos",
    fra: "Badges d'enchantements",
    ita: "Distintivi degli incantesimi",
    jpn: "エンチャントバッジ",
    kor: "마법부여 배지",
    pol: "Odznaki zaklęć",
    ptb: "Emblemas de encantamentos",
    rus: "Значки зачарований",
    spa: "Insignias de encantamientos",
    tha: "ตราเอนแชนต์",
    tur: "Büyü Rozetleri",
    zhs: "附魔徽章",
    zht: "附魔徽章",
  },
  "Enchanted Cards": {
    eng: "Enchanted Cards",
    deu: "Verzauberte Karten",
    esp: "Cartas encantadas",
    fra: "Cartes enchantées",
    ita: "Carte incantate",
    jpn: "エンチャント済みカード",
    kor: "마법부여된 카드",
    pol: "Zaklęte karty",
    ptb: "Cartas encantadas",
    rus: "Зачарованные карты",
    spa: "Cartas encantadas",
    tha: "การ์ดที่ถูกเอนแชนต์",
    tur: "Büyülü Kartlar",
    zhs: "附魔卡牌",
    zht: "附魔卡牌",
  },
  "Afflicted Cards": {
    eng: "Afflicted Cards",
    deu: "Karten mit Leiden",
    esp: "Cartas afligidas",
    fra: "Cartes affligées",
    ita: "Carte afflitte",
    jpn: "苦悩付きカード",
    kor: "고통이 걸린 카드",
    pol: "Karty z przypadłościami",
    ptb: "Cartas afligidas",
    rus: "Карты с недугами",
    spa: "Cartas afligidas",
    tha: "การ์ดที่ถูกสาป",
    tur: "Lanetli Kartlar",
    zhs: "受苦难卡牌",
    zht: "受苦難卡牌",
  },
  "Game Assets": {
    eng: "Game Assets",
    deu: "Spiel-Assets",
    esp: "Recursos del juego",
    fra: "Ressources du jeu",
    ita: "Risorse di gioco",
    jpn: "ゲームアセット",
    kor: "게임 에셋",
    pol: "Zasoby gry",
    ptb: "Recursos do jogo",
    rus: "Игровые ресурсы",
    spa: "Recursos del juego",
    tha: "แอสเซ็ตของเกม",
    tur: "Oyun Varlıkları",
    zhs: "游戏资源",
    zht: "遊戲資源",
  },
  "Main {version}": {
    eng: "Main {version}",
    deu: "Main {version}",
    esp: "Main {version}",
    fra: "Main {version}",
    ita: "Main {version}",
    jpn: "Main {version}",
    kor: "Main {version}",
    pol: "Main {version}",
    ptb: "Main {version}",
    rus: "Main {version}",
    spa: "Main {version}",
    tha: "Main {version}",
    tur: "Main {version}",
    zhs: "Main {version}",
    zht: "Main {version}",
  },
  "Beta {version}": {
    eng: "Beta {version}",
    deu: "Beta {version}",
    esp: "Beta {version}",
    fra: "Beta {version}",
    ita: "Beta {version}",
    jpn: "Beta {version}",
    kor: "Beta {version}",
    pol: "Beta {version}",
    ptb: "Beta {version}",
    rus: "Beta {version}",
    spa: "Beta {version}",
    tha: "Beta {version}",
    tur: "Beta {version}",
    zhs: "Beta {version}",
    zht: "Beta {version}",
  },
  "Every card as the game draws it, base and upgraded, in every language.": {
    eng: "Every card as the game draws it, base and upgraded, in every language.",
    deu: "Jede Karte, wie das Spiel sie zeichnet, in Grund- und verbesserter Form, in jeder Sprache.",
    esp: "Cada carta tal como la dibuja el juego, básica y mejorada, en todos los idiomas.",
    fra: "Chaque carte telle que le jeu la dessine, de base et améliorée, dans toutes les langues.",
    ita: "Ogni carta come la disegna il gioco, base e potenziata, in tutte le lingue.",
    jpn: "ゲームが描画するすべてのカード。基本版と強化版、全言語対応。",
    kor: "게임이 그리는 모든 카드, 기본과 강화 버전, 모든 언어로.",
    pol: "Każda karta tak, jak rysuje ją gra, podstawowa i ulepszona, w każdym języku.",
    ptb: "Cada carta como o jogo a desenha, básica e aprimorada, em todos os idiomas.",
    rus: "Каждая карта в том виде, как её рисует игра, базовая и улучшенная, на всех языках.",
    spa: "Cada carta tal como la dibuja el juego, básica y mejorada, en todos los idiomas.",
    tha: "การ์ดทุกใบตามที่เกมวาด ทั้งแบบพื้นฐานและอัปเกรด ในทุกภาษา",
    tur: "Oyunun çizdiği haliyle her kart, temel ve geliştirilmiş, her dilde.",
    zhs: "游戏绘制的每一张卡牌，基础版与升级版，全语言。",
    zht: "遊戲繪製的每一張卡牌，基礎版與升級版，全語言。",
  },
  "Frame-by-frame idle animations for cards, characters and monsters.": {
    eng: "Frame-by-frame idle animations for cards, characters and monsters.",
    deu: "Bild-für-Bild-Leerlaufanimationen für Karten, Charaktere und Monster.",
    esp: "Animaciones de reposo fotograma a fotograma de cartas, personajes y monstruos.",
    fra: "Animations d'attente image par image des cartes, personnages et monstres.",
    ita: "Animazioni di attesa fotogramma per fotogramma di carte, personaggi e mostri.",
    jpn: "カード、キャラクター、モンスターの待機アニメーションをコマごとに収録。",
    kor: "카드, 캐릭터, 몬스터의 프레임별 대기 애니메이션.",
    pol: "Klatka po klatce: animacje bezczynności kart, postaci i potworów.",
    ptb: "Animações de espera quadro a quadro de cartas, personagens e monstros.",
    rus: "Покадровые анимации ожидания карт, персонажей и монстров.",
    spa: "Animaciones de reposo fotograma a fotograma de cartas, personajes y monstruos.",
    tha: "แอนิเมชันท่ายืนแบบเฟรมต่อเฟรมของการ์ด ตัวละคร และมอนสเตอร์",
    tur: "Kartlar, karakterler ve canavarlar için kare kare bekleme animasyonları.",
    zhs: "卡牌、角色与怪物的逐帧待机动画。",
    zht: "卡牌、角色與怪物的逐格待機動畫。",
  },
  "Every monster on its idle pose, trimmed to the art.": {
    eng: "Every monster on its idle pose, trimmed to the art.",
    deu: "Jedes Monster in seiner Ruhepose, auf die Grafik zugeschnitten.",
    esp: "Cada monstruo en su pose de reposo, recortado al arte.",
    fra: "Chaque monstre dans sa pose d'attente, recadré sur l'illustration.",
    ita: "Ogni mostro nella posa di attesa, ritagliato sull'immagine.",
    jpn: "すべてのモンスターの待機ポーズ。絵に合わせてトリミング済み。",
    kor: "모든 몬스터의 대기 자세, 그림에 맞춰 잘라냄.",
    pol: "Każdy potwór w pozie bezczynności, przycięty do grafiki.",
    ptb: "Cada monstro em sua pose de espera, recortado na arte.",
    rus: "Каждый монстр в позе ожидания, обрезанный по рисунку.",
    spa: "Cada monstruo en su pose de reposo, recortado al arte.",
    tha: "มอนสเตอร์ทุกตัวในท่ายืน ตัดขอบพอดีกับภาพ",
    tur: "Her canavar bekleme duruşunda, çizime göre kırpılmış.",
    zhs: "每个怪物的待机姿势，按画面裁切。",
    zht: "每個怪物的待機姿勢，依畫面裁切。",
  },
  "Alternate skins for the monsters that have them.": {
    eng: "Alternate skins for the monsters that have them.",
    deu: "Alternative Skins für die Monster, die welche haben.",
    esp: "Aspectos alternativos de los monstruos que los tienen.",
    fra: "Skins alternatifs des monstres qui en ont.",
    ita: "Skin alternative per i mostri che ne hanno.",
    jpn: "スキンを持つモンスターの別スキン。",
    kor: "스킨이 있는 몬스터의 대체 스킨.",
    pol: "Alternatywne skórki potworów, które je mają.",
    ptb: "Skins alternativas dos monstros que as têm.",
    rus: "Альтернативные скины монстров, у которых они есть.",
    spa: "Aspectos alternativos de los monstruos que los tienen.",
    tha: "สกินทางเลือกของมอนสเตอร์ที่มี",
    tur: "Kostümü olan canavarların alternatif kostümleri.",
    zhs: "拥有皮肤的怪物的替换皮肤。",
    zht: "擁有外觀的怪物的替換外觀。",
  },
  "The playable characters on their idle pose.": {
    eng: "The playable characters on their idle pose.",
    deu: "Die spielbaren Charaktere in ihrer Ruhepose.",
    esp: "Los personajes jugables en su pose de reposo.",
    fra: "Les personnages jouables dans leur pose d'attente.",
    ita: "I personaggi giocabili nella posa di attesa.",
    jpn: "プレイアブルキャラクターの待機ポーズ。",
    kor: "플레이 가능한 캐릭터의 대기 자세.",
    pol: "Grywalne postacie w pozie bezczynności.",
    ptb: "Os personagens jogáveis em sua pose de espera.",
    rus: "Игровые персонажи в позе ожидания.",
    spa: "Los personajes jugables en su pose de reposo.",
    tha: "ตัวละครที่เล่นได้ในท่ายืน",
    tur: "Oynanabilir karakterler bekleme duruşunda.",
    zhs: "可操作角色的待机姿势。",
    zht: "可操作角色的待機姿勢。",
  },
  "Characters with their form effects active.": {
    eng: "Characters with their form effects active.",
    deu: "Charaktere mit aktiven Formeffekten.",
    esp: "Personajes con los efectos de su forma activos.",
    fra: "Personnages avec les effets de leur forme actifs.",
    ita: "Personaggi con gli effetti della forma attivi.",
    jpn: "フォーム効果が発動中のキャラクター。",
    kor: "형태 효과가 활성화된 캐릭터.",
    pol: "Postacie z aktywnymi efektami formy.",
    ptb: "Personagens com os efeitos de sua forma ativos.",
    rus: "Персонажи с активными эффектами формы.",
    spa: "Personajes con los efectos de su forma activos.",
    tha: "ตัวละครขณะเปิดใช้เอฟเฟกต์ร่าง",
    tur: "Form efektleri etkin karakterler.",
    zhs: "形态效果激活时的角色。",
    zht: "形態效果啟用時的角色。",
  },
  "Every relic's art, with the beta-art versions in their own folder.": {
    eng: "Every relic's art, with the beta-art versions in their own folder.",
    deu: "Die Grafik jedes Relikts, die Beta-Art-Versionen in einem eigenen Ordner.",
    esp: "El arte de cada reliquia, con las versiones de arte beta en su propia carpeta.",
    fra: "L'illustration de chaque relique, les versions d'art bêta dans leur propre dossier.",
    ita: "L'immagine di ogni reliquia, con le versioni beta in una cartella a parte.",
    jpn: "すべてのレリックのアート。ベータ版アートは別フォルダに収録。",
    kor: "모든 유물의 그림, 베타 그림 버전은 별도 폴더에.",
    pol: "Grafika każdego reliktu, wersje beta w osobnym folderze.",
    ptb: "A arte de cada relíquia, com as versões de arte beta em sua própria pasta.",
    rus: "Рисунок каждой реликвии, бета-версии в отдельной папке.",
    spa: "El arte de cada reliquia, con las versiones de arte beta en su propia carpeta.",
    tha: "ภาพของเรลิกทุกชิ้น โดยเวอร์ชันภาพเบต้าอยู่ในโฟลเดอร์แยก",
    tur: "Her kalıntının çizimi, beta çizim sürümleri kendi klasöründe.",
    zhs: "每件遗物的美术图，测试版美术单独存放。",
    zht: "每件遺物的美術圖，測試版美術單獨存放。",
  },
  "Every potion, rendered at its in-game size.": {
    eng: "Every potion, rendered at its in-game size.",
    deu: "Jeder Trank, gerendert in seiner Spielgröße.",
    esp: "Cada poción, renderizada a su tamaño en el juego.",
    fra: "Chaque potion, rendue à sa taille en jeu.",
    ita: "Ogni pozione, renderizzata alla dimensione di gioco.",
    jpn: "すべてのポーション。ゲーム内サイズでレンダリング。",
    kor: "모든 물약, 게임 내 크기로 렌더링.",
    pol: "Każda mikstura wyrenderowana w rozmiarze z gry.",
    ptb: "Cada poção, renderizada em seu tamanho no jogo.",
    rus: "Каждое зелье в игровом размере.",
    spa: "Cada poción, renderizada a su tamaño en el juego.",
    tha: "โพชันทุกขวด เรนเดอร์ในขนาดเท่าในเกม",
    tur: "Her iksir, oyun içi boyutunda işlenmiş.",
    zhs: "每种药水，按游戏内尺寸渲染。",
    zht: "每種藥水，依遊戲內尺寸渲染。",
  },
  "Room, event and menu backdrops at full resolution.": {
    eng: "Room, event and menu backdrops at full resolution.",
    deu: "Raum-, Ereignis- und Menühintergründe in voller Auflösung.",
    esp: "Fondos de salas, eventos y menús a resolución completa.",
    fra: "Décors de salles, d'événements et de menus en pleine résolution.",
    ita: "Sfondi di stanze, eventi e menu a piena risoluzione.",
    jpn: "部屋、イベント、メニューの背景をフル解像度で収録。",
    kor: "방, 이벤트, 메뉴 배경을 원본 해상도로.",
    pol: "Tła pomieszczeń, zdarzeń i menu w pełnej rozdzielczości.",
    ptb: "Cenários de salas, eventos e menus em resolução completa.",
    rus: "Фоны комнат, событий и меню в полном разрешении.",
    spa: "Fondos de salas, eventos y menús a resolución completa.",
    tha: "ฉากหลังของห้อง เหตุการณ์ และเมนูที่ความละเอียดเต็ม",
    tur: "Oda, olay ve menü arka planları tam çözünürlükte.",
    zhs: "房间、事件与菜单背景，全分辨率。",
    zht: "房間、事件與選單背景，全解析度。",
  },
  "The frame, banner and cost pieces the game composes cards from.": {
    eng: "The frame, banner and cost pieces the game composes cards from.",
    deu: "Die Rahmen-, Banner- und Kostenteile, aus denen das Spiel Karten zusammensetzt.",
    esp: "Las piezas de marco, estandarte y coste con las que el juego compone las cartas.",
    fra: "Les pièces de cadre, de bannière et de coût dont le jeu compose les cartes.",
    ita: "I pezzi di cornice, stendardo e costo con cui il gioco compone le carte.",
    jpn: "ゲームがカードを組み立てるフレーム、バナー、コストのパーツ。",
    kor: "게임이 카드를 조합하는 테두리, 배너, 비용 조각.",
    pol: "Elementy ramki, banera i kosztu, z których gra składa karty.",
    ptb: "As peças de moldura, faixa e custo com que o jogo monta as cartas.",
    rus: "Части рамки, ленты и стоимости, из которых игра собирает карты.",
    spa: "Las piezas de marco, estandarte y coste con las que el juego compone las cartas.",
    tha: "ชิ้นส่วนกรอบ แถบ และค่าใช้จ่ายที่เกมใช้ประกอบการ์ด",
    tur: "Oyunun kartları oluşturduğu çerçeve, şerit ve maliyet parçaları.",
    zhs: "游戏拼合卡牌所用的边框、横幅与费用部件。",
    zht: "遊戲拼合卡牌所用的邊框、橫幅與費用部件。",
  },
  "The small badge each enchantment shows on a card.": {
    eng: "The small badge each enchantment shows on a card.",
    deu: "Das kleine Abzeichen, das jede Verzauberung auf einer Karte zeigt.",
    esp: "La pequeña insignia que cada encantamiento muestra en una carta.",
    fra: "Le petit badge que chaque enchantement affiche sur une carte.",
    ita: "Il piccolo distintivo che ogni incantesimo mostra su una carta.",
    jpn: "各エンチャントがカード上に表示する小さなバッジ。",
    kor: "각 마법부여가 카드에 표시하는 작은 배지.",
    pol: "Mała odznaka, którą każde zaklęcie pokazuje na karcie.",
    ptb: "O pequeno emblema que cada encantamento mostra em uma carta.",
    rus: "Маленький значок, который каждое зачарование показывает на карте.",
    spa: "La pequeña insignia que cada encantamiento muestra en una carta.",
    tha: "ตราขนาดเล็กที่เอนแชนต์แต่ละแบบแสดงบนการ์ด",
    tur: "Her büyünün bir kartta gösterdiği küçük rozet.",
    zhs: "每种附魔在卡牌上显示的小徽章。",
    zht: "每種附魔在卡牌上顯示的小徽章。",
  },
  "Every card crossed with every enchantment it can carry, per language.": {
    eng: "Every card crossed with every enchantment it can carry, per language.",
    deu: "Jede Karte kombiniert mit jeder Verzauberung, die sie tragen kann, pro Sprache.",
    esp: "Cada carta cruzada con cada encantamiento que puede llevar, por idioma.",
    fra: "Chaque carte croisée avec chaque enchantement qu'elle peut porter, par langue.",
    ita: "Ogni carta incrociata con ogni incantesimo che può portare, per lingua.",
    jpn: "各カードと付与可能なすべてのエンチャントの組み合わせ。言語別。",
    kor: "각 카드에 붙일 수 있는 모든 마법부여 조합, 언어별.",
    pol: "Każda karta w połączeniu z każdym zaklęciem, jakie może nosić, według języka.",
    ptb: "Cada carta cruzada com cada encantamento que pode carregar, por idioma.",
    rus: "Каждая карта в сочетании с каждым зачарованием, которое она может нести, по языкам.",
    spa: "Cada carta cruzada con cada encantamiento que puede llevar, por idioma.",
    tha: "การ์ดทุกใบจับคู่กับเอนแชนต์ทุกแบบที่ใส่ได้ แยกตามภาษา",
    tur: "Her kart, taşıyabildiği her büyüyle çaprazlanmış, dil başına.",
    zhs: "每张卡牌与其可附加的每种附魔的组合，按语言划分。",
    zht: "每張卡牌與其可附加的每種附魔的組合，依語言劃分。",
  },
  "Every card crossed with every affliction, per language.": {
    eng: "Every card crossed with every affliction, per language.",
    deu: "Jede Karte kombiniert mit jedem Leiden, pro Sprache.",
    esp: "Cada carta cruzada con cada aflicción, por idioma.",
    fra: "Chaque carte croisée avec chaque affliction, par langue.",
    ita: "Ogni carta incrociata con ogni afflizione, per lingua.",
    jpn: "各カードとすべての苦悩の組み合わせ。言語別。",
    kor: "각 카드와 모든 고통의 조합, 언어별.",
    pol: "Każda karta w połączeniu z każdą przypadłością, według języka.",
    ptb: "Cada carta cruzada com cada aflição, por idioma.",
    rus: "Каждая карта в сочетании с каждым недугом, по языкам.",
    spa: "Cada carta cruzada con cada aflicción, por idioma.",
    tha: "การ์ดทุกใบจับคู่กับคำสาปทุกแบบ แยกตามภาษา",
    tur: "Her kart, her lanetle çaprazlanmış, dil başına.",
    zhs: "每张卡牌与每种苦难的组合，按语言划分。",
    zht: "每張卡牌與每種苦難的組合，依語言劃分。",
  },
  "The full texture dump: UI, map, powers, orbs, effects and everything else.":
    {
      eng: "The full texture dump: UI, map, powers, orbs, effects and everything else.",
      deu: "Der komplette Textur-Dump: UI, Karte, Kräfte, Orbs, Effekte und alles andere.",
      esp: "El volcado completo de texturas: interfaz, mapa, poderes, orbes, efectos y todo lo demás.",
      fra: "L'extraction complète des textures : interface, carte, pouvoirs, orbes, effets et tout le reste.",
      ita: "Il dump completo delle texture: interfaccia, mappa, poteri, sfere, effetti e tutto il resto.",
      jpn: "テクスチャの全ダンプ。UI、マップ、パワー、オーブ、エフェクトなどすべて。",
      kor: "전체 텍스처 덤프: UI, 지도, 파워, 오브, 효과 및 그 외 전부.",
      pol: "Pełny zrzut tekstur: interfejs, mapa, moce, kule, efekty i cała reszta.",
      ptb: "O despejo completo de texturas: interface, mapa, poderes, orbes, efeitos e todo o resto.",
      rus: "Полный дамп текстур: интерфейс, карта, силы, сферы, эффекты и всё остальное.",
      spa: "El volcado completo de texturas: interfaz, mapa, poderes, orbes, efectos y todo lo demás.",
      tha: "ดัมพ์เท็กซ์เจอร์ทั้งหมด: UI แผนที่ พลัง ออร์บ เอฟเฟกต์ และอื่น ๆ ทั้งหมด",
      tur: "Tam doku dökümü: arayüz, harita, güçler, küreler, efektler ve diğer her şey.",
      zhs: "完整贴图导出：界面、地图、能力、法球、特效及其他一切。",
      zht: "完整貼圖匯出：介面、地圖、能力、法球、特效及其他一切。",
    },
  "Beta art": {
    eng: "Beta art",
    deu: "Beta-Art",
    esp: "Arte beta",
    fra: "Art bêta",
    ita: "Arte beta",
    jpn: "ベータ版アート",
    kor: "베타 그림",
    pol: "Grafika beta",
    ptb: "Arte beta",
    rus: "Бета-рисунки",
    spa: "Arte beta",
    tha: "ภาพเบต้า",
    tur: "Beta çizim",
    zhs: "测试版美术",
    zht: "測試版美術",
  },
  English: {
    eng: "English",
    deu: "Englisch",
    esp: "Inglés",
    fra: "Anglais",
    ita: "Inglese",
    jpn: "英語",
    kor: "영어",
    pol: "Angielski",
    ptb: "Inglês",
    rus: "Английский",
    spa: "Inglés",
    tha: "อังกฤษ",
    tur: "İngilizce",
    zhs: "英语",
    zht: "英文",
  },
  Cards: {
    eng: "Cards",
    deu: "Karten",
    esp: "Cartas",
    fra: "Cartes",
    ita: "Carte",
    jpn: "カード",
    kor: "카드",
    pol: "Karty",
    ptb: "Cartas",
    rus: "Карты",
    spa: "Cartas",
    tha: "การ์ด",
    tur: "Kartlar",
    zhs: "卡牌",
    zht: "卡牌",
  },
  Characters: {
    eng: "Characters",
    deu: "Charaktere",
    esp: "Personajes",
    fra: "Personnages",
    ita: "Personaggi",
    jpn: "キャラクター",
    kor: "캐릭터",
    pol: "Postacie",
    ptb: "Personagens",
    rus: "Персонажи",
    spa: "Personajes",
    tha: "ตัวละคร",
    tur: "Karakterler",
    zhs: "角色",
    zht: "角色",
  },
  Monsters: {
    eng: "Monsters",
    deu: "Monster",
    esp: "Monstruos",
    fra: "Monstres",
    ita: "Mostri",
    jpn: "モンスター",
    kor: "몬스터",
    pol: "Potwory",
    ptb: "Monstros",
    rus: "Монстры",
    spa: "Monstruos",
    tha: "มอนสเตอร์",
    tur: "Canavarlar",
    zhs: "怪物",
    zht: "怪物",
  },
  Ancients: {
    eng: "Ancients",
    deu: "Uralte",
    esp: "Ancestrales",
    fra: "Anciens",
    ita: "Antichi",
    jpn: "エンシェント",
    kor: "고대의 존재",
    pol: "Pradawni",
    ptb: "Ancestrais",
    rus: "Древние",
    spa: "Ancestrales",
    tha: "ผู้เก่าแก่",
    tur: "Kadimler",
    zhs: "远古者",
    zht: "遠古者",
  },
  "Atlas sprites": {
    eng: "Atlas sprites",
    deu: "Atlas-Sprites",
    esp: "Sprites de atlas",
    fra: "Sprites d'atlas",
    ita: "Sprite degli atlanti",
    jpn: "アトラスのスプライト",
    kor: "아틀라스 스프라이트",
    pol: "Sprite'y z atlasów",
    ptb: "Sprites de atlas",
    rus: "Спрайты из атласов",
    spa: "Sprites de atlas",
    tha: "สไปรต์จากแอตลาส",
    tur: "Atlas sprite'ları",
    zhs: "图集精灵图",
    zht: "圖集精靈圖",
  },
  Atlases: {
    eng: "Atlases",
    deu: "Atlanten",
    esp: "Atlas",
    fra: "Atlas",
    ita: "Atlanti",
    jpn: "アトラス",
    kor: "아틀라스",
    pol: "Atlasy",
    ptb: "Atlas",
    rus: "Атласы",
    spa: "Atlas",
    tha: "แอตลาส",
    tur: "Atlaslar",
    zhs: "图集",
    zht: "圖集",
  },
  "Card overlays": {
    eng: "Card overlays",
    deu: "Karten-Overlays",
    esp: "Superposiciones de cartas",
    fra: "Superpositions de cartes",
    ita: "Sovrapposizioni delle carte",
    jpn: "カードのオーバーレイ",
    kor: "카드 오버레이",
    pol: "Nakładki kart",
    ptb: "Sobreposições de cartas",
    rus: "Наложения карт",
    spa: "Superposiciones de cartas",
    tha: "เลเยอร์ซ้อนการ์ด",
    tur: "Kart kaplamaları",
    zhs: "卡牌叠加层",
    zht: "卡牌疊加層",
  },
  Debug: {
    eng: "Debug",
    deu: "Debug",
    esp: "Depuración",
    fra: "Débogage",
    ita: "Debug",
    jpn: "デバッグ",
    kor: "디버그",
    pol: "Debugowanie",
    ptb: "Depuração",
    rus: "Отладка",
    spa: "Depuración",
    tha: "ดีบัก",
    tur: "Hata ayıklama",
    zhs: "调试",
    zht: "除錯",
  },
  Enchantments: {
    eng: "Enchantments",
    deu: "Verzauberungen",
    esp: "Encantamientos",
    fra: "Enchantements",
    ita: "Incantesimi",
    jpn: "エンチャント",
    kor: "마법부여",
    pol: "Zaklęcia",
    ptb: "Encantamentos",
    rus: "Зачарования",
    spa: "Encantamientos",
    tha: "เอนแชนต์",
    tur: "Büyüler",
    zhs: "附魔",
    zht: "附魔",
  },
  Events: {
    eng: "Events",
    deu: "Ereignisse",
    esp: "Eventos",
    fra: "Événements",
    ita: "Eventi",
    jpn: "イベント",
    kor: "이벤트",
    pol: "Zdarzenia",
    ptb: "Eventos",
    rus: "События",
    spa: "Eventos",
    tha: "เหตุการณ์",
    tur: "Olaylar",
    zhs: "事件",
    zht: "事件",
  },
  Tutorial: {
    eng: "Tutorial",
    deu: "Tutorial",
    esp: "Tutorial",
    fra: "Tutoriel",
    ita: "Tutorial",
    jpn: "チュートリアル",
    kor: "튜토리얼",
    pol: "Samouczek",
    ptb: "Tutorial",
    rus: "Обучение",
    spa: "Tutorial",
    tha: "บทช่วยสอน",
    tur: "Eğitim",
    zhs: "教程",
    zht: "教學",
  },
  Map: {
    eng: "Map",
    deu: "Karte",
    esp: "Mapa",
    fra: "Carte",
    ita: "Mappa",
    jpn: "マップ",
    kor: "지도",
    pol: "Mapa",
    ptb: "Mapa",
    rus: "Карта",
    spa: "Mapa",
    tha: "แผนที่",
    tur: "Harita",
    zhs: "地图",
    zht: "地圖",
  },
  Orbs: {
    eng: "Orbs",
    deu: "Orbs",
    esp: "Orbes",
    fra: "Orbes",
    ita: "Sfere",
    jpn: "オーブ",
    kor: "오브",
    pol: "Kule",
    ptb: "Orbes",
    rus: "Сферы",
    spa: "Orbes",
    tha: "ออร์บ",
    tur: "Küreler",
    zhs: "法球",
    zht: "法球",
  },
  Other: {
    eng: "Other",
    deu: "Sonstiges",
    esp: "Otros",
    fra: "Autres",
    ita: "Altro",
    jpn: "その他",
    kor: "기타",
    pol: "Inne",
    ptb: "Outros",
    rus: "Прочее",
    spa: "Otros",
    tha: "อื่น ๆ",
    tur: "Diğer",
    zhs: "其他",
    zht: "其他",
  },
  Packed: {
    eng: "Packed",
    deu: "Gepackt",
    esp: "Empaquetados",
    fra: "Empaquetés",
    ita: "Impacchettati",
    jpn: "パック済み",
    kor: "패킹됨",
    pol: "Spakowane",
    ptb: "Empacotados",
    rus: "Упакованные",
    spa: "Empaquetados",
    tha: "แพ็กรวม",
    tur: "Paketlenmiş",
    zhs: "已打包",
    zht: "已打包",
  },
  Potions: {
    eng: "Potions",
    deu: "Tränke",
    esp: "Pociones",
    fra: "Potions",
    ita: "Pozioni",
    jpn: "ポーション",
    kor: "물약",
    pol: "Mikstury",
    ptb: "Poções",
    rus: "Зелья",
    spa: "Pociones",
    tha: "โพชัน",
    tur: "İksirler",
    zhs: "药水",
    zht: "藥水",
  },
  Powers: {
    eng: "Powers",
    deu: "Kräfte",
    esp: "Poderes",
    fra: "Pouvoirs",
    ita: "Poteri",
    jpn: "パワー",
    kor: "파워",
    pol: "Moce",
    ptb: "Poderes",
    rus: "Силы",
    spa: "Poderes",
    tha: "พลัง",
    tur: "Güçler",
    zhs: "能力",
    zht: "能力",
  },
  Relics: {
    eng: "Relics",
    deu: "Relikte",
    esp: "Reliquias",
    fra: "Reliques",
    ita: "Reliquie",
    jpn: "レリック",
    kor: "유물",
    pol: "Relikty",
    ptb: "Relíquias",
    rus: "Реликвии",
    spa: "Reliquias",
    tha: "เรลิก",
    tur: "Kalıntılar",
    zhs: "遗物",
    zht: "遺物",
  },
  Rooms: {
    eng: "Rooms",
    deu: "Räume",
    esp: "Salas",
    fra: "Salles",
    ita: "Stanze",
    jpn: "部屋",
    kor: "방",
    pol: "Pomieszczenia",
    ptb: "Salas",
    rus: "Комнаты",
    spa: "Salas",
    tha: "ห้อง",
    tur: "Odalar",
    zhs: "房间",
    zht: "房間",
  },
  Timeline: {
    eng: "Timeline",
    deu: "Zeitleiste",
    esp: "Línea temporal",
    fra: "Chronologie",
    ita: "Linea temporale",
    jpn: "タイムライン",
    kor: "타임라인",
    pol: "Oś czasu",
    ptb: "Linha do tempo",
    rus: "Хронология",
    spa: "Línea temporal",
    tha: "ไทม์ไลน์",
    tur: "Zaman çizelgesi",
    zhs: "时间线",
    zht: "時間線",
  },
  UI: {
    eng: "UI",
    deu: "Benutzeroberfläche",
    esp: "Interfaz",
    fra: "Interface",
    ita: "Interfaccia",
    jpn: "UI",
    kor: "UI",
    pol: "Interfejs",
    ptb: "Interface",
    rus: "Интерфейс",
    spa: "Interfaz",
    tha: "UI",
    tur: "Arayüz",
    zhs: "界面",
    zht: "介面",
  },
  Effects: {
    eng: "Effects",
    deu: "Effekte",
    esp: "Efectos",
    fra: "Effets",
    ita: "Effetti",
    jpn: "エフェクト",
    kor: "효과",
    pol: "Efekty",
    ptb: "Efeitos",
    rus: "Эффекты",
    spa: "Efectos",
    tha: "เอฟเฟกต์",
    tur: "Efektler",
    zhs: "特效",
    zht: "特效",
  },
  Combat: {
    eng: "Combat",
    deu: "Kampf",
    esp: "Combate",
    fra: "Combat",
    ita: "Combattimento",
    jpn: "戦闘",
    kor: "전투",
    pol: "Walka",
    ptb: "Combate",
    rus: "Бой",
    spa: "Combate",
    tha: "การต่อสู้",
    tur: "Savaş",
    zhs: "战斗",
    zht: "戰鬥",
  },
  Credits: {
    eng: "Credits",
    deu: "Mitwirkende",
    esp: "Créditos",
    fra: "Crédits",
    ita: "Riconoscimenti",
    jpn: "クレジット",
    kor: "크레딧",
    pol: "Twórcy",
    ptb: "Créditos",
    rus: "Титры",
    spa: "Créditos",
    tha: "เครดิต",
    tur: "Jenerik",
    zhs: "制作人员",
    zht: "製作人員",
  },
  Emotes: {
    eng: "Emotes",
    deu: "Emotes",
    esp: "Gestos",
    fra: "Émotes",
    ita: "Emote",
    jpn: "エモート",
    kor: "감정 표현",
    pol: "Emotki",
    ptb: "Emotes",
    rus: "Эмоции",
    spa: "Gestos",
    tha: "อีโมต",
    tur: "İfadeler",
    zhs: "表情",
    zht: "表情",
  },
  "Game over screen": {
    eng: "Game over screen",
    deu: "Game-Over-Bildschirm",
    esp: "Pantalla de fin de partida",
    fra: "Écran de fin de partie",
    ita: "Schermata di fine partita",
    jpn: "ゲームオーバー画面",
    kor: "게임 오버 화면",
    pol: "Ekran końca gry",
    ptb: "Tela de fim de jogo",
    rus: "Экран конца игры",
    spa: "Pantalla de fin de partida",
    tha: "หน้าจอจบเกม",
    tur: "Oyun sonu ekranı",
    zhs: "游戏结束画面",
    zht: "遊戲結束畫面",
  },
  Hands: {
    eng: "Hands",
    deu: "Hände",
    esp: "Manos",
    fra: "Mains",
    ita: "Mani",
    jpn: "手",
    kor: "손",
    pol: "Dłonie",
    ptb: "Mãos",
    rus: "Руки",
    spa: "Manos",
    tha: "มือ",
    tur: "Eller",
    zhs: "手部",
    zht: "手部",
  },
  "Main menu": {
    eng: "Main menu",
    deu: "Hauptmenü",
    esp: "Menú principal",
    fra: "Menu principal",
    ita: "Menu principale",
    jpn: "メインメニュー",
    kor: "메인 메뉴",
    pol: "Menu główne",
    ptb: "Menu principal",
    rus: "Главное меню",
    spa: "Menú principal",
    tha: "เมนูหลัก",
    tur: "Ana menü",
    zhs: "主菜单",
    zht: "主選單",
  },
  Mods: {
    eng: "Mods",
    deu: "Mods",
    esp: "Mods",
    fra: "Mods",
    ita: "Mod",
    jpn: "MOD",
    kor: "모드",
    pol: "Mody",
    ptb: "Mods",
    rus: "Моды",
    spa: "Mods",
    tha: "ม็อด",
    tur: "Modlar",
    zhs: "模组",
    zht: "模組",
  },
  Profile: {
    eng: "Profile",
    deu: "Profil",
    esp: "Perfil",
    fra: "Profil",
    ita: "Profilo",
    jpn: "プロフィール",
    kor: "프로필",
    pol: "Profil",
    ptb: "Perfil",
    rus: "Профиль",
    spa: "Perfil",
    tha: "โปรไฟล์",
    tur: "Profil",
    zhs: "档案",
    zht: "檔案",
  },
  "Rest site": {
    eng: "Rest site",
    deu: "Rastplatz",
    esp: "Zona de descanso",
    fra: "Site de repos",
    ita: "Luogo di riposo",
    jpn: "休憩所",
    kor: "휴식처",
    pol: "Miejsce odpoczynku",
    ptb: "Local de descanso",
    rus: "Место отдыха",
    spa: "Zona de descanso",
    tha: "จุดพัก",
    tur: "Dinlenme yeri",
    zhs: "休息点",
    zht: "休息點",
  },
  "Reward screen": {
    eng: "Reward screen",
    deu: "Belohnungsbildschirm",
    esp: "Pantalla de recompensas",
    fra: "Écran de récompenses",
    ita: "Schermata delle ricompense",
    jpn: "報酬画面",
    kor: "보상 화면",
    pol: "Ekran nagród",
    ptb: "Tela de recompensas",
    rus: "Экран наград",
    spa: "Pantalla de recompensas",
    tha: "หน้าจอรางวัล",
    tur: "Ödül ekranı",
    zhs: "奖励画面",
    zht: "獎勵畫面",
  },
  "Run history": {
    eng: "Run history",
    deu: "Run-Verlauf",
    esp: "Historial de partidas",
    fra: "Historique des parties",
    ita: "Cronologia delle partite",
    jpn: "ラン履歴",
    kor: "런 기록",
    pol: "Historia przejść",
    ptb: "Histórico de jogadas",
    rus: "История забегов",
    spa: "Historial de partidas",
    tha: "ประวัติการเล่น",
    tur: "Koşu geçmişi",
    zhs: "游戏记录",
    zht: "遊戲紀錄",
  },
  "Top panel": {
    eng: "Top panel",
    deu: "Obere Leiste",
    esp: "Panel superior",
    fra: "Panneau supérieur",
    ita: "Pannello superiore",
    jpn: "上部パネル",
    kor: "상단 패널",
    pol: "Górny panel",
    ptb: "Painel superior",
    rus: "Верхняя панель",
    spa: "Panel superior",
    tha: "แถบด้านบน",
    tur: "Üst panel",
    zhs: "顶部面板",
    zht: "頂部面板",
  },
  Transitions: {
    eng: "Transitions",
    deu: "Übergänge",
    esp: "Transiciones",
    fra: "Transitions",
    ita: "Transizioni",
    jpn: "トランジション",
    kor: "전환 효과",
    pol: "Przejścia",
    ptb: "Transições",
    rus: "Переходы",
    spa: "Transiciones",
    tha: "ทรานซิชัน",
    tur: "Geçişler",
    zhs: "过渡效果",
    zht: "過渡效果",
  },
};
